// third-party
import { createSlice } from '@reduxjs/toolkit';

// types
import { DefaultRootStateProps } from 'types';
import { Topic } from "../../types/type/activities-types";

// ----------------------------------------------------------------------

const initialState: DefaultRootStateProps['topic'] = {
    error: null,
    topic: [],
};

const topic = createSlice({
    name: 'topic',
    initialState,
    reducers: {
        // HAS ERROR
        hasError(state, action) {
            state.error = action.payload;
        },

        //GET ALL TOPICS
        getAllTopics(state, action) {
            state.topic = action.payload;
        },

        //INSERT NEW TOPIC
        insertNewTopic(state, action) {
            state.topic.push(action.payload);
        },

        //UPDATE TOPIC
        updateTopic(state, action) {
            const localState = state.topic.map((el: Topic) => {
                if (el.id == action.payload.id) {
                    el = action.payload
                }
                return el
            })
            Object.assign(state.topic, localState)
        },

        //DELETE TOPIC
        deleteTopic(state, action) {
            state.topic = state.topic.filter((el: Topic) => el.id != action.payload.toString());
        },
    }
});

// Reducer
export default topic;

// ----------------------------------------------------------------------